module.exports = __webpack_public_path__ + "img/zk-icon-commodity-group.9f70cc18.svg";